import React from "react";
import { getSmallest, getIntentByDate } from "./Main";
import { formatCurrency, getClassNames } from "../../shared/utils";

const Total = ({ goIntent, backIntent, searchIntents, tripType, fetching }) => {
	let goPrice, backPrice, totalWithTaxes;
	const goData = getIntentByDate(goIntent, searchIntents);
	const backAndForthData = getIntentByDate(backIntent, searchIntents, true);

	if (tripType === "OW") {
		goPrice = getSmallest(goData, { withTaxes: true, leg: "out" });
		totalWithTaxes = goPrice;
	} else {
		goPrice = backAndForthData
			? getSmallest(backAndForthData, { withTaxes: true, leg: "out" })
			: null;
		backPrice = backAndForthData
			? getSmallest(backAndForthData, { withTaxes: true, leg: "in" })
			: null;
		totalWithTaxes = (goPrice || 0) + (backPrice || 0);
	}

	const totalPrice = totalWithTaxes ? `${formatCurrency(totalWithTaxes)}` : "-";

	const classNames = getClassNames({
		"price-calendar-total": true,
		"price-calendar-total--empty": !goIntent && !backIntent
	});

	return (
		<div className={classNames}>
			<div className="price-calendar-total__row">
				<div className="price-calendar-total__info price-calendar-total__info--go">
					<span>Voo de ida:</span>
					<strong>{!fetching && goPrice ? `${formatCurrency(goPrice)}` : "-"}</strong>
				</div>
				{tripType === "RT" && (
					<div className="price-calendar-total__info price-calendar-total__info--back">
						<span className="visible-xs visible-sm">Volta:</span>
						<span className="hidden-xs hidden-sm">Voo de volta:</span>
						<strong>{!fetching && backPrice ? `${formatCurrency(backPrice)}` : "-"}</strong>
					</div>
				)}
			</div>
			<div className="price-calendar-total__row price-calendar-total__row--taxes">
				Total (c/ taxas): <strong>{totalPrice}</strong>
			</div>
		</div>
	);
};

export default Total;
